<template>
  <div v-if="showMenu">
    <div class="report-menu">
      <div v-if="currentReport.id" class="share">
        <router-link :to="`/report/${currentReport.id}/folder/${inspection.id}/forward`">
          Email
        </router-link>
      </div>
    </div>
    <div class="folder">
      <router-link :to="folderLink">Inspection Details</router-link>
    </div>
    <div v-if="currentReport.downloadLink" class="download">
      <a :href="currentReport.downloadLink">PDF</a>
    </div>
    <div v-if="currentReport.hasSummary" class="download summary" @click="showSummary">Summary</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      hgSummary: null,
      summaryMessageCounter: 0,
    };
  },
  mounted() {
    this.addMessageHandler();
  },
  destroyed() {
    this.removeMessageHandler();
  },
  computed: {
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    currentReport() {
      if (!this.inspection || !this.inspection.reports) {
        return null;
      }
      return this.inspection.reports
        .find(report => report.id.toString() === this.$route.params.reportId);
    },
    showMenu() {
      return this.$route.name === 'reportView';
    },
    folderLink() {
      return `/inspection/${this.inspection.id}/`;
    },
  },
  methods: {
    addMessageHandler() {
      window.addEventListener('message', this.receiveHgSummaryMessage);
    },
    removeMessageHandler() {
      window.removeEventListener('message', this.receiveHgSummaryMessage);
    },
    receiveHgSummaryMessage(m) {
      if (m.data.hgsummary) {
        /**
         * Not always the first message includes the whole summary,
         * i believe this is why classic tries to check 10 times for a complete summary.
         * and so i'm removing the event listener at the 3rd message
         * and hoping it's got the full summary
         */
        this.summaryMessageCounter += 1;
        if (this.summaryMessageCounter > 1) {
          this.$store.dispatch('Inspection/setReportHasSummary', this.currentReport.id);
          this.hgSummary = m.data.hgsummary;
        }
      }
    },
    showSummary() {
      /* eslint-disable max-len, quotes, no-tabs, no-trailing-spaces,
      indent, prefer-template, no-restricted-globals, comma-dangle */
      let theBody = "";
				
				theBody += "<html>";
				theBody += "  <head>";
				theBody += "		<base href='" + this.currentReport.link + "'>";
				theBody += "		<title>Summary</title>";
				theBody += "		<link rel='stylesheet' type='text/css' href='report.css'>";
					theBody += "<link  rel='stylesheet' type='text/css' href='/css/summary-print.css'>";

				theBody += "	</head>";
				theBody += "	<body>";
				theBody += "		<div class='pagebreakline' style='background-color:#fff; padding:15px; text-align:right;'>";
				theBody += "			<a href='#' onClick='javascript:window.print();return false;' style=\"font-size:18px; font-weight:bold;\"><img src=\"/images/report/printerIcon.gif\" width=\"20\" height=\"15\" border=\"0\" align=\"absmiddle\" />Print Summary</a>";
				theBody += "		</div>";
				theBody += "		<br>";
				theBody += "    " + this.hgSummary;
				theBody += "	</body>";
				theBody += "</html>";
				
				const win = window.open("", "summaryPrint", "toolbar=no, status=no, width=600, height=600, resizable=yes, scrollbars=yes");
				win.document.write(theBody);
				win.document.close();					
        /* eslint-enable max-len, quotes, no-tabs, no-trailing-spaces,
        indent, no-restricted-globals, comma-dangle */
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/icons';
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

@mixin iconBackground($icon-url) {
  background: transparent $icon-url scroll no-repeat left center;
}

a, .summary {
  color: rgba(0,0,0, 0.55);
  font-family: $typography-font-secondary;
  font-size: 1rem;
  font-weight: $typography-weight-bold;
  min-width: 88px;
  padding: 2px 2px 2px 20px;
  text-transform: uppercase;
}

.summary {
  cursor: pointer;
}

.download,
.summary,
.folder,
.share {
  display: inline-block;
  padding: 15px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.download a {
  @include iconBackground($icon-image-download);
}

.folder a {
  @include iconBackground($icon-image-file);
  background-size: 13px;
}

.share a {
  @include iconBackground($icon-image-share);
}

.report-menu {
  float: right;
}

@media only screen and (max-width: 960px) {
  .report-menu {
    display: flex;
    flex-direction: column;
    float: left;
    width: 100%;

    div {
      border-top: solid 1px rgba(0, 0, 0, 0.15);

      &:last-child {
        border-bottom: solid 1px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
